import noUiSlider from 'nouislider';

export default function () {
  let stepSlider = document.querySelector('.jsSlider');
  let value = document.querySelector('.jsSliderValue');
  let points = document.querySelectorAll('.jsSlider-point')
  let sentence = document.getElementById('measure-impact-sentence')


  if (stepSlider !== null && stepSlider !== undefined) {
    noUiSlider.create(stepSlider, {
      start: [ parseInt(stepSlider.getAttribute('data-jsslider-start'), 10) ],
      snap: true,
      connect: true,
      range: {
        'min': parseInt(points[0].dataset.amount, 10),
        '17%': parseInt(points[1].dataset.amount, 10),
        '34%': parseInt(points[2].dataset.amount, 10),
        '51%': parseInt(points[3].dataset.amount, 10),
        '68%': parseInt(points[4].dataset.amount, 10),
        '85%': parseInt(points[5].dataset.amount, 10),
        'max': parseInt(points[6].dataset.amount, 10)
      },
      format: {
        to: function (value) {
          return parseInt(value, 10)
        },

        from: function (value) {
          return parseInt(value, 10)
        }
      }
    });

    stepSlider.noUiSlider.on('update', function( values, handle, unencoded, tap, positions ) {

      console.log(values, handle)

      value.innerHTML = '$' + values[handle].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").split('.')[0];

      const item = document.querySelector(`[data-amount="${parseInt(values[handle], 10)}"]`)

      console.log(item)

      if (item) {
        sentence.innerHTML = item.dataset.sentence
      }
    });
  }
}
